export default __webpack_public_path__ + "static/media/Test3.f1688c8b.png";